/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateFindByEmail } from '../../axios/candidateFindByEmail'
import type {
	CandidateFindByEmailError,
	CandidateFindByEmailRequest,
	CandidateFindByEmailResponse,
} from '../../types/CandidateFindByEmail'

export const candidateFindByEmailMutationKey = () => [{ url: '/candidates/find' }] as const

export type CandidateFindByEmailMutationKey = ReturnType<typeof candidateFindByEmailMutationKey>

export type CandidateFindByEmailVariables = {
	data: CandidateFindByEmailRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::findByEmail */
export function useCandidateFindByEmail<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateFindByEmailResponse,
		AxiosError<CandidateFindByEmailError>,
		CandidateFindByEmailVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateFindByEmailMutationKey(),
		mutationFn: ({ data }: CandidateFindByEmailVariables) =>
			candidateFindByEmail(data, config).then(res => res.data),
		...options,
	})
}
